import LocalStorageHandler from './LocalStorageHandler';

const localStorageHandler = new LocalStorageHandler();

export { localStorageHandler };
